import { render, staticRenderFns } from "./ProspectivesDashboard.vue?vue&type=template&id=18c5f6a4"
import script from "./ProspectivesDashboard.vue?vue&type=script&lang=js"
export * from "./ProspectivesDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports